export default __webpack_public_path__ + "static/media/cat-5-7.98c47995.png";